import React, {useState, useEffect} from 'react';
import {IdentifierForm, AuthMethodForm} from '../../../../features';
import styles from './AuthWidget.module.scss';
import {Button, Card, Icon, Text} from '@gravity-ui/uikit';
import {AuthMethodType} from '../../../../features/auth/model';
import {getSessionItem} from '../../../../shared';
import {ArrowLeft} from '@gravity-ui/icons/';
import classNames from 'classnames';

// Ключ для хранения метода авторизации в localStorage
const AUTH_METHOD_KEY = 'auth_method';

export const AuthWidget = ({onRestart}: {onRestart?: () => void}) => {
  // Получаем сохраненный метод авторизации при монтировании компонента
  const [authMethod, setAuthMethod] = useState<AuthMethodType>(null);

  // При монтировании компонента проверяем наличие сохраненного метода авторизации
  useEffect(() => {
    const savedAuthMethod = localStorage.getItem(AUTH_METHOD_KEY) as AuthMethodType;
    const identifier = getSessionItem('auth_identifier');

    // Восстанавливаем метод авторизации только если есть идентификатор
    if (savedAuthMethod && identifier) {
      setAuthMethod(savedAuthMethod);
    }
  }, []);

  // Обновляем authMethod и сохраняем его в localStorage
  const handleAuthMethodChange = (method: AuthMethodType) => {
    setAuthMethod(method);
    if (method) {
      localStorage.setItem(AUTH_METHOD_KEY, method);
    } else {
      localStorage.removeItem(AUTH_METHOD_KEY);
    }
  };

  // Обработка возврата на предыдущий шаг
  const handleBack = () => {
    setAuthMethod(null);
    localStorage.removeItem(AUTH_METHOD_KEY);
  };

  return (
    <Card type={'container'} theme={'normal'} view={'raised'} size={'l'} className={styles.authWidget}>
      <div className={styles.backButtonContainer}>
        {authMethod && (
          <Button view={'flat'} size="m" onClick={handleBack} className={styles.backButton}>
            <Icon data={ArrowLeft} />
          </Button>
        )}
        <Text
          className={classNames(styles.authTitle, {[styles.authTitleWithBackButton]: authMethod})}
          variant={'header-2'}>
          Авторизация
        </Text>
      </div>

      {!authMethod && <IdentifierForm authMethod={authMethod} onSelectAuthMethod={handleAuthMethodChange} />}

      {authMethod && <AuthMethodForm authMethod={authMethod} />}

      {onRestart && (
        <div className={styles.actions}>
          <Button view={'flat'} size={'l'} onClick={onRestart}>
            Начать заново
          </Button>
        </div>
      )}
    </Card>
  );
};
